var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseWhiteChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseWhiteChat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M348.114,35.9004563 C347.843717,35.6295641 347.476769,35.4773271 347.0941,35.4773271 C346.711431,35.4773271 346.344483,35.6295641 346.0742,35.9004563 L339,42.9601896 L331.9258,35.8859896 C331.655517,35.6150974 331.288569,35.4628604 330.9059,35.4628604 C330.523231,35.4628604 330.156283,35.6150974 329.886,35.8859896 C329.3218,36.4501896 329.3218,37.3615896 329.886,37.9257896 L336.9602,44.9999896 L329.886,52.0741896 C329.3218,52.6383896 329.3218,53.5497896 329.886,54.1139896 C330.4502,54.6781896 331.3616,54.6781896 331.9258,54.1139896 L339,47.0397896 L346.0742,54.1139896 C346.6384,54.6781896 347.5498,54.6781896 348.114,54.1139896 C348.6782,53.5497896 348.6782,52.6383896 348.114,52.0741896 L341.0398,44.9999896 L348.114,37.9257896 C348.663733,37.3760563 348.663733,36.4501896 348.114,35.9004563 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_VideoChatOnly",
    transform: "translate(-329.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseWhiteChat",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhiteChat);
export default __webpack_public_path__ + "static/media/icCloseWhiteChat.29423c90b97bcde58d0bf0606a993cf4.svg";
export { ForwardRef as ReactComponent };